window.$ = window.jQuery = require("jquery");

require("slick-carousel");

require("@fancyapps/fancybox");

$(document).ready(function () {
	/** Click on link or button that opens the popup. It contain "#elementor-action" in href. */
	$(document).on("click", "a[href*='#elementor-action']", function () {
		/** Let's give the elementor some time to animate popup. */
		setTimeout(function () {
			/** Find all Contact 7 forms inside elementor popup. */
			$(".elementor-popup-modal form.wpcf7-form:not(.elementor)").each(
				function (index) {
					console.log(wpcf7);
					wpcf7.init($(this)[0]); // Extra initialisation for contact 7 form.
					$(this).addClass("elementor"); // Mark our form with class '.elementor' so as not to do the same thing.
				}
			);
		}, 800); // END Timeout.
	}); // END link click.

	const clickAuto = () => {
		console.log($("#vehiculos").find(".ver"));
		$("#vehiculos")
			.find(".ver")
			.on("click", function (e) {
				console.log("ok");
				e.preventDefault();
				const target = $(this).data("target");
				console.log(target);
				$("#vehiculos")
					.find(".detalles")
					.not($(`#${target}`))
					.stop()
					.slideUp(function () {
						$(`#${target}`)
							.stop()
							.slideDown(function () {
								if ($(`#${target}`).length) {
									let alto_cabecera = 100;
									$([
										document.documentElement,
										document.body,
									]).animate(
										{
											scrollTop:
												$(`#${target}`).offset().top -
												alto_cabecera,
										},
										1000
									);
								}
							});
					});
			});
	};

	$("#vehiculos .slide")
		.on("init breakpoint", function () {
			setTimeout(() => {
				clickAuto();
			}, 2000);
		})
		.slick({
			dots: false,
			infinite: false,
			speed: 300,
			slidesToShow: 3,
			slidesToScroll: 1,
			centerMode: false,
			variableWidth: false,
			arrows: false,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
					},
				},
				{
					breakpoint: 540,
					settings: {
						slidesToShow: 1,
					},
				},
			],
		});
});
